export default __webpack_public_path__ + "static/media/delete_icon.73c7b2fa.svg";